import { createRouter, createWebHistory } from 'vue-router'
import { routes, handleHotUpdate } from 'vue-router/auto-routes'
import { setupLayouts } from 'virtual:generated-layouts'
import { applyErrorsGuard } from './middleware/errors'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: setupLayouts(routes),
  scrollBehavior(to, _from, savedPosition) {
    // if the route has a hash, scroll to that element smoothly
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    // if there is a saved position (e.g., from back navigation), return to it
    if (savedPosition) {
      return savedPosition
    }
    // Otherwise, scroll to the top of the page smoothly
    return { top: 0, left: 0, behavior: 'smooth' }
  },
})

applyErrorsGuard(router)

export default router

if (import.meta.hot) {
  handleHotUpdate(router)
}